import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { AdminOrderShipmentProductCosmeticBrandResponse } from './admin-order-shipment-product-cosmetic-brand.response';

@jsonObject
export class AdminOrderShipmentProductCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(AdminOrderShipmentProductCosmeticBrandResponse)
  public readonly cosmeticBrand?: Nillable<AdminOrderShipmentProductCosmeticBrandResponse>;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile?: Nillable<MultimediaResponse>;
}
